import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type TimeValueInputProps, TimeValueInput } from '../time-value-input';

type FormTimeValueInputProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  TimeValueInputProps;

function FormTimeValueInput<TFieldValues extends FieldValues = FieldValues>(
  props: FormTimeValueInputProps<TFieldValues>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <TimeValueInput
      {...props}
      {...field}
      error={!!error}
      helperText={error?.message ?? props.helperText}
      required={Boolean(props.rules?.required ?? props.required)}
      ref={ref}
      onChange={(value) => {
        field.onChange(value);
        props.onChange?.(value);
      }}
    />
  );
}

export type { FormTimeValueInputProps };
export { FormTimeValueInput };
